import "core-js/modules/es.promise.js";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import axios from "axios";
export function isUserLogged() {
  return __awaiter(this, void 0, void 0, function* () {
    try {
      //@ts-ignore
      var res = yield axios.get("".concat(window["_baseURLIt"], "/rest/isPublicUserLogged"), {
        headers: {
          "Cache-Control": "no-cache"
        }
      });
      //If the response succeeds then we will return the value...
      if (res.status === 200) {
        return res.data;
      }
      //...in any other case we will consider an invalid response!
      return false;
    } catch (error) {
      console.error({
        error
      });
      //This may happen due to a connection error
      return false;
    }
  });
}
export function isMailConfirmed() {
  return __awaiter(this, void 0, void 0, function* () {
    try {
      //@ts-ignore
      var res = yield axios.get("".concat(window["_baseURLIt"], "/rest/publicUser/isMailConfirmed"), {
        headers: {
          "Cache-Control": "no-cache"
        }
      });
      //If the response succeeds then we will return the value...
      if (res.status === 200) {
        return res.data;
      }
      //...in any other case we will consider an invalid response!
      return false;
    } catch (error) {
      console.error({
        error
      });
      //This may happen due to a connection error
      return false;
    }
  });
}
export function doLogin(data) {
  return __awaiter(this, void 0, void 0, function* () {
    return yield axios.post("/rest/publicLogin?username=".concat(data.username, "&password=").concat(data.password));
  });
}
export function doProLogin(data) {
  return __awaiter(this, void 0, void 0, function* () {
    return yield axios.post("/rest/auth/formLogin?username=".concat(data.username, "&password=").concat(data.password));
  });
}
export function signinPublicUser(publicUser) {
  return axios.post("/rest/publicUser/registerUser", publicUser);
}
export function passwordRecovery(data) {
  return axios.post("/rest/publicUser/sendResetPassword", data);
}
export function doLogout() {
  return axios.get("/rest/doLogout");
}
export function resendConfirmationEmail(email) {
  return axios.post("/rest/publicUser/resendConfirmationMail/".concat(email));
}
export function resetPublicUserPassword(data) {
  return axios.post("/rest/publicUser/resetPassword", data);
}
export function updatePublicUser(data) {
  return axios.post("/rest/publicUser/updateUser", data);
}